











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvitationLinkErrorExpired_massInvitation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    }
  ],
  "type": "MassInvitationPayload",
  "abstractKey": null
};

(node ).hash = "7c867960574a78b13cae77e25350485f";

export default node;
